import groupTableTemplate from './reactAdministrationGroupsTable.html';
import { reactGroupCols, defaultSortModel } from './groupsColDefs';
import {ReactTableController} from "../../reactTableController";
import {groups, USER_ACC} from "../../../../services/arsweb/RoutingPaths";
import {ADMINISTRATION_ACCOUNT_GROUPS_TITLE} from "../../../../services/arsweb/TableTitles";
import {AccountService} from "../../../../services/AccountService";
import { EXPORT_TYPE } from "../../../export/ExportModalController";
import {EDITROUTE, EDITTITLE, ADDROUTE, DELETEROUTE, DELETETITLE, DETAIL_GROUPROUTE} from "../../../../routes/accountGroups.route";

/** @ngInject */
export function reactAdministrationGroupsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@'
        },
        templateUrl: groupTableTemplate,
        controller: ReactAdministratonGroupsTableController,
        controllerAs: 'groupsTableController'
    };
}

/** @ngInject */
export class ReactAdministratonGroupsTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies ) {

        super($scope, userService, arsMainDependencies, DETAIL_GROUPROUTE, new AccountService(userService), groups,
            ADMINISTRATION_ACCOUNT_GROUPS_TITLE, 'groupsTableParams', "groupId", true, [], defaultSortModel);
        this.backendService.service.config.params.filter = {};
        this.userService = userService;
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid());
    }

    initGrid() {

        this.userService.promise.then(()=> {
            // react account columns
            this.colDefs = reactGroupCols(this.translate, this.userService.filterFormatter);
			this.initCols();
            this.globalActions.push( {label: this.translate.instant(DELETETITLE),
                handleAction:() => this.delete(this.gridApi.getSelectedNodes(), DELETEROUTE)});
            // react gridParameters for groups table
            const groupGridParams = {
                columnDefs: this.colDefs,
                url: this.backendService.service.getServiceUrl(USER_ACC + groups),
                onAdd: () =>  this.state.go(ADDROUTE),
                rowActions: () => { return [{
                    label: this.translate.instant(EDITTITLE),
                    handleAction: (params) => this.state.go(EDITROUTE, { id: params.data.groupId})
                }, {
                    label: this.translate.instant(DELETETITLE),
                    handleAction: (params) => this.deleteRow(params.data.groupId, params.data.groupName, DELETEROUTE)
                }];
                }
            };
            delete this.defaultReactGridParams.onReport;
            delete this.defaultReactGridParams.onSearchInputChange;
            this.reactGridParams = {...this.defaultReactGridParams, ...groupGridParams};
        })
    }

    displayElementsForConfirmation() {
        return this.gridApi.getSelectedNodes().map(node => node.data.groupName);
    }

    tableExport(params) {
        const downloadFunction = params.reportType.value === EXPORT_TYPE.XLSX.value ? 'downloadZIP_Xls' : 'downloadZIP';
        this.reportServices.exportFileForReact(null, downloadFunction);
    }
}
